import type { useAnalyticsEvents } from '@atlaskit/analytics-next';
import type { ErrorInfo } from 'react';

export type SpotlightAction = 'started' | 'dismissed' | 'completed' | 'skipped' | 'next';

type TrackSpotlightEventParams = {
	createAnalyticsEvent: ReturnType<typeof useAnalyticsEvents>['createAnalyticsEvent'];
	action: SpotlightAction;
	step: number | null;
};

export const trackSpotlightEvent = ({
	createAnalyticsEvent,
	action,
	step,
}: TrackSpotlightEventParams) => {
	createAnalyticsEvent({
		type: 'sendTrackEvent',
		data: {
			source: 'confluence',
			actionSubject: 'spotlight',
			action: 'actioned',
			attributes: {
				action,
				step: step !== null ? step : undefined,
			},
		},
	}).fire();
};

type TrackErrorEventParams = {
	createAnalyticsEvent: ReturnType<typeof useAnalyticsEvents>['createAnalyticsEvent'];
	error: Error;
	errorInfo: ErrorInfo;
	componentName: 'export-jira-context-nudge' | 'export-jira-context-nudge-spotlight-tour';
};

export const trackErrorEvent = ({
	createAnalyticsEvent,
	error,
	errorInfo,
	componentName,
}: TrackErrorEventParams) => {
	createAnalyticsEvent({
		type: 'sendOperationalEvent',
		data: {
			action: 'reported',
			actionSubject: `${componentName}-error`,
			source: 'confluence',
			attributes: {
				name: error.name,
				msg: error.message,
				stack: error.stack,
				componentStack: errorInfo.componentStack,
			},
		},
	}).fire();
};
